module.exports = __webpack_public_path__ + "static/hw1-65ce524072e6029ea9736443860e0cce.jpg";